'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var experience = function experience() {
  return import('@/page/experienceBase/base.vue');
};
var experienceBase = function experienceBase() {
  return import('@/page/experienceBase');
};
var experienceBaseDetail = function experienceBaseDetail() {
  return import('@/page/experienceBase/detail');
};
exports.default = [{
  path: '/experience',
  name: 'experience',
  component: experience,
  children: [{
    path: '/experienceBase',
    name: 'experienceBase',
    component: experienceBase
  }, {
    path: 'experienceBaseDetail',
    name: 'experienceBaseDetail',
    component: experienceBaseDetail
  }]
}];